var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initComplete)?_c('div',{attrs:{"id":"shopping-list-app"}},[_c('nav-bar'),_c('div',{staticClass:"container grid-lg"},[_c('router-view')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }